import { Button, Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { Link } from 'react-router';
import { styled, css } from 'styled-components';

import { SmallContainer } from 'src/components/container';
import { Image } from 'src/components/image';
import { Link as ExternalLink } from 'src/components/link';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorSecondary050, colorSecondary800, colorSecondary900 } from 'src/styles/colors';
import { focus } from 'src/styles/mixins';

export const commonLinkStyles = css`
  color: ${colorSecondary900};
  font-weight: bold;
  text-decoration: none;
  border-bottom: 2px solid ${colorSecondary900};
  padding-bottom: 2px;

  &:hover {
    color: ${colorSecondary800};
    border-bottom: 2px solid ${colorSecondary800};
  }
`;

export const StyledBreadcrumb = styled.div`
  height: 48px;

  @media (min-width: ${breakpointLargeTablet}) {
    height: 72px;
    background: ${colorSecondary050};
  }
`;

export const StyledContainer = styled(SmallContainer)`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const StyledLinkContainer = styled.div`
  color: ${colorSecondary900};
  font-weight: bold;
  font-size: 20px;

  &:not(:last-child)::after {
    content: '/';
    padding: 0 13px;
  }
`;

export const StyledLink = styled(Link)`
  font-size: 18px;
  ${focus};
  ${commonLinkStyles};
`;

export const StyledButton = styled(Button)`
  margin: 0;
  padding: 0;
`;

export const StyledArrowLeftIcon = styled(Image)`
  /* stylelint-disable declaration-no-important */
  width: 18px !important;
  height: 14px !important;
  margin-right: 0 !important;
  /* stylelint-enable declaration-no-important */
`;

export const StyledText = styled(Typography)`
  font-weight: bold;
`;

export const StyledExternalLink = styled(ExternalLink)`
  ${commonLinkStyles};
`;
